import React, { useCallback } from 'react';
import { useRouter } from 'next/router';
import styled from 'styled-components';
import { layout, space, flexbox, border, color, position } from 'styled-system';
import { CircleFlag } from 'react-circle-flags';
import StatusLabel from 'theme/status-label';
import Text from 'theme/text';

const Wrapper = styled.button`
  position: relative;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  flex: 1;
  width: 100%;
  min-width: 390px;
  min-height: 148px;
  box-sizing: border-box;
  border-radius: 8px;
  padding: 16px 16px 16px 32px;

  ${space}
  ${border}
  ${color}
  ${layout}
`;

const Flex = styled.div`
  display: flex;

  ${flexbox}
  ${space}
  ${position}
`;

const StyledText = styled(Text)`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  user-select: none;
`;

const StyledCircleFlag = styled(CircleFlag)`
  width: 22px;
  height: 22px;
  margin-left: 8px;
`;

function TaxInterviewCard({
  id,
  style,
  label,
  year,
  onClick,
  isDraft,
  isDefault,
  countryCode,
  languageCode,
}) {
  const { push } = useRouter();

  const handleClick = useCallback(() => {
    if (onClick) return onClick(id);

    return push({ pathname: '/billing/summary-tax-interview', query: { id } });
  }, [push, onClick, id]);

  return (
    <Wrapper bg="white" {...style} onClick={handleClick}>
      <Flex
        flexDirection="row"
        alignItems="center"
        justifyContent="space-between"
        position="relative"
      >
        <Flex flexDirection="row" alignItems="center">
          {!isDraft && (
            <StatusLabel style={{ p: 0 }} languageCode={languageCode} status="COMPLETE" />
          )}
          {!!isDraft && <StatusLabel style={{ p: 0 }} languageCode={languageCode} status="DRAFT" />}

          {isDefault && (
            <StatusLabel
              style={{ margin: '0 0 0 10px' }}
              languageCode={languageCode}
              status="DEFAULT"
            />
          )}

          {!!countryCode && <StyledCircleFlag countryCode={countryCode.toLowerCase()} />}
        </Flex>
      </Flex>

      <StyledText mt="s" fontSize="h3" lineHeight="h3" fontWeight="bold" color="grey_600">
        {label}
      </StyledText>

      <StyledText
        mt="xs"
        fontSize="display"
        lineHeight="display"
        fontWeight="medium"
        color="grey_400"
      >
        {year}
      </StyledText>
    </Wrapper>
  );
}

export default TaxInterviewCard;
